<template lang="">
  <pageLoader :msg="loadingMsg" v-if="loading"/>
  <div class="commonmargin" v-else>
    <div class="col-12 col-lg-11 col-md-11 col-xl-11 mx-auto">
      <div class="row justify-content-center align-items-start relative">
        <div class="col-lg-5 col-md-5 col-sm-6 vehicle-container">
          <button class="backbuttonTop max-w-md mt-0 mb-3" @click="revisitSingleQuote()"><img src="/images/backarrow.svg" width="12px" class="selectrtosvg" />BACK TO PREVIOUS</button>
          <productDetailsHeader/>
        </div>
        <div class="col-12 col-sm-12 col-md-7 col-lg-7">
          <div class="upload_ckyc_content p-4 pt-0" v-if="!allDocumentSuccess">
            <div class="col-12">
              <div class="row mt-3 p-3 document-list rounded">
                <div class="instructions mt-2 ml-3">
                  <h4 class="heading">Right Way to Upload Your Document</h4>
                  <p>
                    &bull; There should be no flash visible on the photo/scan of the document.
                  </p>
                  <p>&bull; File size should be up to {{ size }}.</p>
                </div>
                <div
                  v-for="(uploadDoc, index) in requirements"
                  class="col-lg-6 col-md-6 col-sm-12 mt-3"
                  :id="'requirement-doc-' + index"
                >
                  <div
                    class="doc-upload_container p-3"
                    v-if="afterDocsUploaded.length > 0"
                  >
                    <h4 class="heading">
                      {{ uploadDoc.docCategoryDescription }}
                      <text class="mandatory-mark">*</text>
                    </h4>
                    <div class="mt-2">
                      <select
                        style="text-transform: capitalize"
                        v-model="afterDocsUploaded[index].SBDocId"
                        :name="uploadDoc.SBDocCategory"
                        :id="uploadDoc.SBDocCategory"
                        class="w-100 p-2 rounded"
                        v-if="uploadDoc.allowedSBDocId.length > 1"
                      >
                        <option
                          style="text-transform: capitalize"
                          value="0"
                          selected
                          disabled
                        >
                          SELECT
                        </option>
                        <option
                          style="text-transform: capitalize"
                          v-for="(docName, ind) in uploadDoc.allowedSBDocId.sort(
                            (a, b) =>
                              a.docIdDescription.localeCompare(b.docIdDescription)
                          )"
                          :value="docName.SBDocId"
                        >
                          {{ docName.docIdDescription?.toUpperCase() }}
                        </option>
                      </select>
                      <select
                        v-model="uploadDoc.allowedSBDocId[0].SBDocId"
                        :name="uploadDoc.SBDocCategory"
                        :id="uploadDoc.SBDocCategory"
                        class="w-100 p-2 rounded"
                        v-else-if="uploadDoc.allowedSBDocId.length === 1"
                      >
                        <option
                          style="text-transform: capitalize"
                          selected
                          :value="uploadDoc.allowedSBDocId[0].SBDocId"
                        >
                          {{ uploadDoc.allowedSBDocId[0].docIdDescription?.toUpperCase() }}
                        </option>
                      </select>
                      <p class="info_message mb-1 mt-2" v-if="afterDocsUploaded[index].SBDocId && uploadDoc.allowedSBDocId.find(doc => doc.SBDocId == afterDocsUploaded[index].SBDocId)?.docIdDescription != 'PAN' "><b>NOTE: </b> Please ensure you are uploading a front & back sides for {{ uploadDoc.allowedSBDocId.find(doc => doc.SBDocId == afterDocsUploaded[index].SBDocId)?.docIdDescription }}.</p>
                    </div>
                    <div class="container-ckyc_document mt-3">
                      <div class="card">
                        <div
                          class="drop_box d-flex flex-column align-items-center"
                          v-if="!afterDocsUploaded[index].docFormat"
                        >
                          <img
                            src="@/assets/images/upload-icon-new.png"
                            alt="upload-icon"
                            width="110"
                            height="110"
                          />
                          <h4 class="heading mt-3 fw-bold">Select File here</h4>
                          <p>
                            Files Supported:
                            {{
                              uploadDoc.fileType
                                .split(",")
                                .map((type) => type.toUpperCase())
                                .join(", ")
                            }}
                          </p>
                          <input
                            style="position: absolute; top: 0; bottom: 0; left: 0; right: 0;"
                            type="file"
                            :accept="
                              uploadDoc.fileType
                                .split(',')
                                .map((type) => '.' + type)
                                .join(',')
                            "
                            :id="'fileID' + index"
                            @change="
                              handleFileUpload(
                                $event,
                                uploadDoc,
                                index,
                                uploadDoc.SBDocCategory
                              )
                            "
                            :disabled="isUploadDisabled(index)"
                          />
                        </div>
                        <div class="drop_box p-3" v-else>
                          <img
                            v-if="
                              afterDocsUploaded[index].docFormat == 'png' ||
                              afterDocsUploaded[index].docFormat == 'jpg' ||
                              afterDocsUploaded[index].docFormat == 'jpeg'
                            "
                            :src="
                              'data:image/' +
                              afterDocsUploaded[index].docFormat +
                              ';base64,' +
                              afterDocsUploaded[index].byteArray
                            "
                            alt="Uploaded Image"
                            class="img-fluid"
                          />
                          <iframe
                            v-if="afterDocsUploaded[index].docFormat == 'pdf'"
                            :src="getPdfBlobUrl(afterDocsUploaded[index].byteArray)"
                            width="100%"
                            height="300px"
                          />
                        </div>
                        <div
                          class="d-flex gap-4 align-items-center justify-content-center"
                          v-if="afterDocsUploaded[index].byteArray"
                        >
                          <span
                            @click="viewDocument(afterDocsUploaded[index])"
                            class="action-buttons d-flex gap-1 align-items-center"
                            ><img
                              src="@/assets/images/eyeicon.svg"
                              alt=""
                              width="20"
                            />View</span
                          >
                          <span
                            @click="
                              removeDocument(afterDocsUploaded[index], index)
                            "
                            class="action-buttons d-flex gap-1 align-items-center"
                            ><img
                              src="@/assets/images/remove-25.png"
                              alt=""
                            />Remove</span
                          >
                        </div>
                      </div>
                    </div>
                    <span
                      :class="{
                        errorText:
                          afterDocsUploaded[index].statusText.type === 'error',
                        successText:
                          afterDocsUploaded[index].statusText.type === 'success',
                      }"
                      class="d-block mt-2"
                      :id="'error-msg-' + uploadDoc.SBDocCategory"
                      v-if="afterDocsUploaded[index].statusText != undefined"
                      style="font-size: 14px"
                      >{{ afterDocsUploaded[index].statusText.text }}</span
                    >
                    <!-- <template v-if=""> -->
                    <!-- <button :disabled="!afterDocsUploaded[index].SBDocId || !afterDocsUploaded[index].byteArray" class="mt-3 btn btn-warning text-white border-0" @click="uploadCkycDocument(afterDocsUploaded[index], index)" v-if="!afterDocsUploaded[index].statusText.text">Upload</button> -->
                    <!-- </template> -->
                  </div>
                </div>
                <button
                  :disabled="handleButtonDIsabled()"
                  class="mt-3 btn py-2 btn-upload btn-warning text-white border-0"
                  @click="uploadCkycDocument()"
                >
                  Upload Documents
                </button>
              </div>
            </div>
          </div>
          <h1 class="text-success" v-else>All Documents Already Uploaded</h1>
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-end">
                <!-- <button class="btn btn-warning text-white border-0" @click="proceedToNextPage()">
                    {{ this.nextJourney === 'proposal' ? 'Continue To Proposal' : 'Continue To Payment'}}
                  </button> -->
                <button
                  class="btn btn-warning text-white border-0"
                  disabled
                  v-if="allDocumentSuccess"
                >
                  {{
                    this.nextJourney === "proposal"
                      ? "Proceeding To Review Page..."
                      : "Proceeding To Payment..."
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="document-view_popup" v-if="viewDocumentObj.flag">
        <div class="overlay-container p-0">
          <span @click="closeDocumentView()">&#x2715;</span>
          <div class="overlay-conntent">
            <img
              :src="viewDocumentObj.file"
              alt=""
              v-if="viewDocumentObj.type == 'image'"
            />
            <iframe
              v-if="viewDocumentObj.type == 'pdf'"
              :src="viewDocumentObj.file"
              width="100%"
              height="600px"
            ></iframe>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import pageLoader from "@/components/pageLoaders/pageLoader.vue";
import productDetailsHeader from "../productDetailsHeader/ProductDetailsHeader.vue";
import { navigateToPaymentStatusOutcome } from '@/lib/payment/navigate-payment-outcome';
import { PAYMENT_STATUS_OUTCOME_SUCCESS } from '@/lib/payment/payment-status-constants';
import { usesDiyConfirmPayment } from '@/utils/diyCustomerRole';
export default {
  name: "KycDocumentsUpload",
  components: {
    pageLoader,
    productDetailsHeader
  },
  data() {
    return {
      loading: true,
      configData: "",
      rmData: "",
      requestJson: "",
      proposalJson: "",
      selectedPlan: "",
      noOfAdult: 0,
      noOfChild: 0,
      userData: {},
      userData: "",
      channel_type: "",
      panNumber: "",
      dateOfBirth: "",
      quoteResponseId: "",
      kycResponse: "",
      kycStatus: "",
      kycRedirectUrl: "",
      errorMsg: [],
      msg: [],
      addOnsData: [],
      selectedPolicyIndex: "",
      apiCallCounter: 0,
      journey_id: sessionStorage.getItem("journey_id")
        ? JSON.parse(sessionStorage.getItem("journey_id"))
        : "",
      isUploadDocRequired: false,
      manuApplicationNo: "",
      requirements: [],
      afterDocsUploaded: [],
      isCkycFailed: false,
      showUploadDocumentSection: false,
      allowedFormats: ["png", "jpeg", "jpg", "pdf"],
      viewDocumentObj: {
        flag: false,
        type: "",
        file: "",
      },
      allDocsUploadSucceed: [],
      allDocumentSuccess: false,
      nextJourney: "proposal",
      size: "5 MB",
      loadingMsg: "Fetching the documents...",
      kycMode: "",
    };
  },
  async mounted() {
    console.log('this.$route', this.$route);
    if (this.$route.query.nextRef) {
      this.nextJourney = this.$route.query.nextRef;
    }
    console.log("store data: ", this.$store.state.configData);
    this.configData = this.$store.state.configData;

    let sessionData = sessionStorage.getItem("userProfile");
    if (sessionData != null) {
      this.userData = JSON.parse(sessionData);
    }

    this.selectedPlan = JSON.parse(
      sessionStorage.getItem("selected_plan_data")
    );
    console.log("this.selectedPlan", this.selectedPlan);
    this.requestJson = JSON.parse(sessionStorage.getItem("request_json"));
    sessionStorage.setItem("request_json_flag_proposal", JSON.stringify(1));

    this.quoteResponseId = JSON.parse(
      sessionStorage.getItem("quote_response_id")
    );

    this.requestJson = JSON.parse(sessionStorage.getItem("quote_request"));
    this.channel_type = this.requestJson.distributor.channelType;

    if (sessionStorage.getItem("rm_data")) {
      this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
      let sessionData = sessionStorage.getItem("userProfile");
      if (sessionData != null) {
        this.userData = JSON.parse(sessionData);
      }
    }
    
    const kycMode = this.$store.state.configData["KYCMODE"];
    this.kycMode = kycMode[this.selectedPlan['insuranceAndProducts']['productCode']];
    if (!this.kycMode) {
      this.kycMode = kycMode[this.selectedPlan['insuranceAndProducts']['insuranceCompanyCode']];
    }
    await this.getUploadDocumentsList();
  },
  methods: {
    async getUploadDocumentsList() {
      this.loading = true;
      let userId = sessionStorage.getItem("rm_data")
        ? JSON.parse(sessionStorage.getItem("rm_data")).UserId
        : "";
      let reqData = {
        journey_id: this.journey_id,
        stage: "Document Upload",
        agent_id: userId,
      };
      let headers = {};

      try {
        const response = await this.backendApi(
          "saveProposal",
          reqData,
          headers
        );

        if (response.status === "error") {
          let msg = [response.data.detail];
          this.$router.push({
            path: "/error-page",
            query: { backUrl: "proposer-page", msg: msg },
          });
        } else if (
          response?.data?.errors?.length > 0 ||
          response === "error" ||
          response?.status === "error"
        ) {
          let msg = [];
          for (let i = 0; i < response.data.errors.length; i++) {
            msg.push(response.data.errors[i]["errorIdentifier"]);
          }
          this.$router.push({
            path: "/error-page",
            query: {
              backUrl: "proposal-page",
              msgError: "We are facing some issue while fetching proposal data",
              reqId: response.data.reqId,
              msg: msg,
            },
          });
        } else {
          this.requirements =
            response.data.data.manufacturer.product[0].requirements;
          this.size =
            response.data.data.manufacturer.product[0].requirements[0]?.maxFileSize + " MB";
          setTimeout(() => {
            this.requirements.forEach((doc, index) => {
              this.afterDocsUploaded.push({
                SBDocCategory: doc.SBDocCategory,
                SBDocId:
                  doc.allowedSBDocId && doc.allowedSBDocId.length === 1
                    ? doc.allowedSBDocId[0].SBDocId
                    : 0,
                documentId: "",
                documentExpiryDate: "",
                docFormat: "",
                manuRequirementNo: "",
                pageType: "all",
                byteArray: "",
                varFields: [],
                statusText: {
                  text: "",
                  type: "",
                },
              });
              this.allDocsUploadSucceed.push({
                id: index,
                status: "",
              });
            });
            this.showUploadDocumentSection = true;
          }, 100);
          const docUploadStatus =
            response.data.data.documentUploadStatus.filter((ele) => {
              return ele.insurance_company_status.toLowerCase() == "success";
            });
          if (
            docUploadStatus.length ===
              response.data.data.documentUploadStatus.length &&
            response.data.data.documentUploadStatus.length !== 0
          ) {
            this.allDocumentSuccess = true;
            setTimeout(() => {
              this.proceedToNextPage();
            }, 1200);
          } else {
            this.allDocumentSuccess = false;
          }
          this.loading = false;
        }
      } catch (error) {
        console.log("error msg block : get proposal", error);
        this.loading = false;
      }
    },
    revisitSingleQuote() {
      let route = '/process-wizard';

      if (this.kycMode === 'POST' && this.nextJourney === 'payment') {
        route = '/ckyc-form?nextRef=payment';
      }

      this.$router.push(route).then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 100)
      }).catch(err => {
        console.error('Navigation error:', err);
      });
    },
    viewDocument(documentObj) {
      if (
        documentObj.docFormat === "png" ||
        documentObj.docFormat === "jpg" ||
        documentObj.docFormat === "jpeg"
      ) {
        this.viewDocumentObj.file =
          "data:image/" + documentObj.docFormat + ";base64," + documentObj.byteArray;
        this.viewDocumentObj.type = "image";
      } else if (documentObj.docFormat === "pdf") {
        try {
          const byteCharacters = atob(documentObj.byteArray);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);

          this.viewDocumentObj.file = blobUrl;
          this.viewDocumentObj.type = "pdf";
        } catch (e) {
          console.error("Failed to render PDF file:", e);
          this.viewDocumentObj.file = "";
          this.viewDocumentObj.type = "";
        }
      }
      this.viewDocumentObj.flag = true;
    },
    getPdfBlobUrl(byteArray) {
      try {
        const byteCharacters = atob(byteArray);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArrayUint8 = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArrayUint8], { type: "application/pdf" });
        return URL.createObjectURL(blob);
      } catch (e) {
        console.error("Invalid Base64 PDF for preview", e);
        return "";
      }
    },
    removeDocument(documentObj, index) {
      this.allDocsUploadSucceed.find((doc) => doc.id == index).status = "";
      documentObj.statusText = {
        text: "",
        type: "",
      };
      documentObj.docFormat = "";
      documentObj.byteArray = "";
    },
    async uploadCkycDocument() {
      this.loadingMsg = "Uploading the documents...";
      this.afterDocsUploaded.forEach((element) => {
        delete element.statusText;
      });
      var applicationNumber = this.selectedPlan.trackInfo.manuApplicationNo
        ? this.selectedPlan.trackInfo.manuApplicationNo
        : this.selectedPlan.trackInfo.manufacturerQuoteID;
      if (
        this.nextJourney === "payment" &&
        sessionStorage.getItem("applicationNumber")
      ) {
        applicationNumber = JSON.parse(
          sessionStorage.getItem("applicationNumber")
        );
      } else {
        applicationNumber = this.selectedPlan.trackInfo.manuApplicationNo
          ? this.selectedPlan.trackInfo.manuApplicationNo
          : this.selectedPlan.trackInfo.manufacturerQuoteID;
      }
      let reqData = {
        journey_id: this.journey_id,
        insuranceCompanyCode:
          this.selectedPlan.insuranceAndProducts.insuranceCompanyCode,
        applicationNo: applicationNumber,
        policyNo: "",
        quoteId: this.selectedPlan.trackInfo.manuApplicationNo
          ? this.selectedPlan.trackInfo.manuApplicationNo
          : this.selectedPlan.trackInfo.manufacturerQuoteID,
        proposalId: "",
        individualDetails: [
          {
            memberType: "Life Assured",
            clientId: "",
            relationWithFirstLifeAssured: "Self",
            memberSequenceNumber: 1,
            fileDetails: this.afterDocsUploaded,
          },
        ],
        purpose: "ovd",
      };
      let headers = {};
      this.loading = true;
      
      if (sessionStorage.getItem('kyc_response')) {
        reqData["ckycInfo"] = JSON.parse(sessionStorage.getItem('kyc_response'));
        reqData["manuRequirementNo"] = JSON.parse(sessionStorage.getItem('kyc_response')).kycInfo?.KYC_Number;
      }
      try {
        const response = await this.backendApi(
          "documentUpload",
          reqData,
          headers
        );
        this.loading = false;
        if (response.status === "error") {
          this.afterDocsUploaded[0].statusText = {
            text: response.data.errors[0].errorDisplayMessage,
            type: "error",
          };
          this.allDocsUploadSucceed[0].status = "success";
        } else if (
          response.data.errors.length > 0 ||
          response === "error" ||
          response.status === "error"
        ) {
          this.afterDocsUploaded[0].statusText = {
            text: response.data.errors[0].errorDisplayMessage,
            type: "error",
          };
          this.allDocsUploadSucceed[0].status = "error";
        } else {
          response.data.data?.individualDetails[0].fileDetails.forEach(
            (successFile) => {
              this.afterDocsUploaded.forEach((uploadedFile, index) => {
                if (
                  successFile.SBDocCategory === uploadedFile.SBDocCategory &&
                  successFile.fileUploadStatus.toLowerCase() === "success"
                ) {
                  this.afterDocsUploaded[index].statusText = {
                    text: "✅File Uploaded Successfully.",
                    type: "success",
                  };
                } else if (
                  successFile.SBDocCategory === uploadedFile.SBDocCategory &&
                  successFile.fileUploadStatus.toLowerCase() === "failure"
                ) {
                  this.afterDocsUploaded[index].statusText = {
                    text: successFile.fileUploadStatusDesc?.trim() || "File upload failed. Please try again.",
                    type: "error",
                  };
                }
              });
            }
          );
        }
        const docUploadStatus =
          response.data.data.individualDetails[0].fileDetails.filter((ele) => {
            return ele.fileUploadStatus.toLowerCase() == "success";
          });
        if (
          docUploadStatus.length === this.afterDocsUploaded.length &&
          this.afterDocsUploaded.length !== 0
        ) {
          setTimeout(() => {
            this.proceedToNextPage();
          }, 1200);
        }
      } catch (error) {
        console.log("error msg block : get proposal", error);
        this.loading = false;
      }
    },
    proceedToNextPage() {
      if (this.kycMode === 'POST') {
        this.proceedToPayment();
      } else if (usesDiyConfirmPayment(this.rmData?.RoleId) || this.channel_type == "B2C") {
          this.$router.push('/confirm-payment-diy').then(() => {
            setTimeout(() => {
              window.location.reload();
            }, 100)
          }).catch(err => {
            console.error('Navigation error:', err);
          });
      }
      else {
        this.$router.push('/confirm-payment').then(() => {
            setTimeout(() => {
              window.location.reload();
            }, 100)
          }).catch(err => {
            console.error('Navigation error:', err);
          });
      }
    },
    proceedToProposal() {
      this.$router.push("/proposer-details-check");
    },
    proceedToPayment() {
      const paymentDetails = sessionStorage.getItem('paymentDetails')
        ? JSON.parse(sessionStorage.getItem('paymentDetails'))
        : null;
      if (paymentDetails?.payment_status?.toLowerCase() === 'success') {
        navigateToPaymentStatusOutcome(this.$router, {
          outcome: PAYMENT_STATUS_OUTCOME_SUCCESS,
          journeyId: this.journeyId || this.journey_id,
        });
        return;
      }
      const paymentUrl = JSON.parse(sessionStorage.getItem('payment_url'));
      if (paymentUrl) {
        window.location.href = paymentUrl;
      }
    },
    closeDocumentView() {
      this.viewDocumentObj.flag = false;
      this.viewDocumentObj.type = "";
      this.viewDocumentObj.file = "";
    },
    handleFileUpload(evt, uploadDoc, index, docName) {
      let minFileSize = uploadDoc.minFileSize;
      let maxFileSize = uploadDoc.maxFileSize;
      const file = evt.target.files[0];

      if (file) {
        let fileExtension = file.name.split(".").pop().toLowerCase();
        const fileSizeInMB =
          uploadDoc.fileSizeUnit.toLowerCase() == "mb"
            ? file.size / (1024 * 1024)
            : uploadDoc.fileSizeUnit.toLowerCase() == "kb"
            ? file.size
            : 0;
        if (fileSizeInMB > maxFileSize) {
          this.afterDocsUploaded[index].statusText = {
            text:
              "File size should be up to " +
              maxFileSize +
              uploadDoc.fileSizeUnit,
            type: "error",
          };
        } else if (
          !uploadDoc.fileType
            .toLowerCase()
            .split(",")
            .includes(fileExtension.toLowerCase())
        ) {
          this.afterDocsUploaded[index].statusText = {
            text: "File Format not supported!",
            type: "error",
          };
        } else {
          this.afterDocsUploaded[index].docFormat = fileExtension;
          this.afterDocsUploaded[index].statusText = {
            text: "",
            type: "",
          };

          // Convert file to base64Data
          const reader = new FileReader();
          reader.onload = (e) => {
            let base64Data = "";
            base64Data = e.target.result.split(",")[1];
            this.afterDocsUploaded[index].byteArray = base64Data;
          };

          reader.onerror = () => {
            alert("Failed to read file. Please try again.");
          };

          reader.readAsDataURL(file);
        }
      }
    },
    handleButtonDIsabled() {
      const filteredArray = this.afterDocsUploaded.filter((doc) => {
        return doc.byteArray;
      });
      return !(filteredArray.length === this.afterDocsUploaded.length);
    },
    isUploadDisabled(index) {
      return this.afterDocsUploaded[index].SBDocId === 0 ? true : false;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/components/Kyc.scss";
</style>
